<template >
    <div class="right_box_main">
        <div class="listBox-item">
            
            <el-card>
                <div class="fisthang">
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                        size="mini"
                    >
                        <el-form-item label="纠纷类型" style="margin:0 30 0 0;">
                            <el-input
                                v-model="searchlist.questionDescribe"
                                placeholder="请输入纠纷类型"
                                style="width:120px;"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchlistdata">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="listBox-item">
                    <el-button
                        style="margin-bottom:20px"
                        type="primary"
                        size="mini"
                        @click="showDialog('','add')"
                    >新增</el-button>
                    <!-- 表格盒子 -->
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column align="center" prop="issueType" label="纠纷类型"></el-table-column>
                            <el-table-column align="center" prop="createPersonName" label="创建人"></el-table-column>
                            <el-table-column align="center" prop="createDate" label="创建日期"></el-table-column>

                            <el-table-column align="center" label="操作" width="200">
                                <template slot-scope="scope">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="删除"
                                        placement="top-start"
                                    >
                                        <button
                                            class="tabBtn el-icon-delete tabBtn-delete"
                                            @click="showDialog(scope.row,'delete')"
                                        ></button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="修改"
                                        placement="top-start"
                                    >
                                        <button
                                            @click="showDialog(scope.row,'update')"
                                            class="tabBtn el-icon-edit-outline tabBtn-edit"
                                        ></button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                    </div>

                    <el-dialog :title="add.title" :visible.sync="add.off" width="1100px">
                        <el-form
                            :rules="ruleArr"
                            ref="baseForm"
                            :model="add.form"
                            label-width="120px"
                        >
                            <el-form-item label="纠纷类型名称" prop="issueType">
                                <el-input type="text" v-model="add.form.issueType"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">立即{{add.title}}</el-button>
                            </el-form-item>
                        </el-form>
                    </el-dialog>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
import { tabdata } from "@/mixins/tabledataMix.js";
import { validatePhoneOrMobile } from "@/utils/validate.js";
export default {
    mixins: [tabdata],

    data() {
        return {
            ruleArr: {
                issueType: [
                    {
                        required: true,
                        message: "请输入纠纷类型名称",
                        trigger: "blur"
                    }
                ]
            },
            add: {
                form: {},
                off: false
            },
            type: ""
        };
    },
    methods: {
        onSubmit() {
            this.$refs.baseForm.validate(valid => {
                if (valid) {
                    if (this.type == "add") {
                        post(
                            "/admin/livelihoodsDisability/info/insertPartyPhone",
                            {
                                ...this.add.form
                            }
                        ).then(res => {
                            this.add.off = false;
                            this.$message.success("新增成功");
                            this.getPageDatas();
                        });
                    } else {
                        post(
                            "/admin/livelihoodsDisability/info/updatePartyPhone",
                            {
                                ...this.add.form
                            }
                        ).then(res => {
                            this.add.off = false;
                            this.$message.success("修改成功");
                            this.getPageDatas();
                        });
                    }
                } else {
                    //   console.log("error submit!!");
                    return false;
                }
            });
        },
        showDialog(row, type) {
            this.type = type;
            switch (type) {
                case "add":
                    this.add.off = true;
                    this.add.title = "新增";
                    this.add.form = {};
                    break;
                case "delete":
                    this.$confirm("此操作将删除该热线, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        post(
                            "/admin/livelihoodsDisability/info/deletePartyPhone",
                            {
                                id: row.id
                            }
                        ).then(res => {
                            this.$message({
                                type: "success",
                                message: "删除该热线成功"
                            });
                            this.getPageDatas();
                        });
                    });
                    break;
                case "update":
                    this.add.off = true;
                    this.add.title = "修改";
                    this.add.form = JSON.parse(JSON.stringify(row));
                    break;
            }
        }
    },
    mounted() {
        this.initTableDataUrl(
            "/admin/issueType/info/list"
        );
    },
    created() {}
};
</script>

<style lang="less" scoped>
</style>
 